import { Vue, Component } from 'vue-property-decorator';
import MainHeaderAccounting from './main-header-accounting.vue';

@Component({
  components: {
    MainHeaderAccounting,
  }
})
export default class MainHeader extends Vue { }